import Axios from 'axios'
import App from './main'
// axios实例
const instance = Axios.create({
    //baseURL: Global.HOST,
    baseURL: '/api',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Accept': 'application/json;charset=utf-8'
    }
})
instance.interceptors.request.use(config => {
    config.data = config.data || {}
    let sessionId = window.localStorage.getItem('sessionId')
    if (!sessionId) {
        App.$router.push('/login')
    }
    config.data.sessionId = sessionId
    return config;
})
instance.interceptors.response.use(config => {
    let {retCode, retMsg, data, sessionId} = config.data
    if (sessionId != null) {
        if (retCode == '0') {
            window.localStorage.setItem('sessionId', sessionId)
        } else {
            App.$store.commit('showErrorMsg', retMsg)
        }
    } else {
        if (['user.not.exist', 'user.has.login.expiretime'].indexOf(retCode) > -1) {
            App.$store.commit('showErrorMsg', '请先登陆')
            App.$router.push('/login')
        }
        App.$store.commit('showErrorMsg', retMsg || retCode)
        return Promise.reject({retCode});
    }
    return {data, retCode}
});
export default instance


// WEBPACK FOOTER //
// ./src/axios.config.js